module.exports = __webpack_public_path__ + "media/images/icons/icons_small/3_lips-a09dff55a69993fe614f7d0b8458215a.png";